export const fromBase64 = (data: string): string => {
  return decodeURIComponent(escape(atob(data)));
}